import PropTypes from 'prop-types';

export const wysiwygBlockTypes = PropTypes.shape({
  content: PropTypes.string.isRequired,
  ctaText: PropTypes.any.isRequired,
  secondaryCtaButton: PropTypes.any.isRequired,
});

export const buttonObjectPropTypes = PropTypes.shape({
  handleClick: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
});

export const concertsArrayPropTypes = PropTypes.arrayOf(PropTypes.shape({
  entryId: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  performances: PropTypes.objectOf(
    PropTypes.arrayOf(PropTypes.shape({
      date: PropTypes.string.isRequired,
      time: PropTypes.string.isRequired,
    }).isRequired).isRequired,
  ).isRequired,
  synopsis: PropTypes.string.isRequired,
  teaser: PropTypes.string.isRequired,
  performancesViewTeaser: PropTypes.string.isRequired,
  date: PropTypes.string.isRequired,
  image: PropTypes.string,
  productionSeasonId: PropTypes.number.isRequired,
  detailedContent: PropTypes.shape({
    blocks: PropTypes.arrayOf(wysiwygBlockTypes).isRequired,
  }).isRequired,
  finalPerformanceOffSaleDateAndTime: PropTypes.string.isRequired,
}).isRequired);
